<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Among the Fair Magnolias: Four Southern Love Stories</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="tx" id="Aok"></p>
<p class="ct" id="pz11-2"> <img alt="images/img-7-1.jpg" src="images/img-7-1.jpg" style="vertical-align: middle;"/><a href="#/contents#toc1" id="con1">A NOTE FROM THE AUTHOR</a><img alt="images/img-7-2.jpg" src="images/img-7-2.jpg" style="vertical-align: middle;"/></p>
<p class="tx1" id="pz11-6"> D<span class="small">EAR</span> R<span class="small">EADERS, </span></p>
<p class="tx" id="pz11-7"> Since childhood, the beach is the place where I have felt most alive and closest to God. There is something about the power and beauty of the ocean, the golden light of a sunrise over water that calms my heart and fuels my creativity. Many of my books were first conceived during an early-morning beach walk. When I was offered the chance to write a novella for this collection, I knew right away it would be set on Pawleys Island, South Carolina, one of my favorite places on earth. </p>
<p class="tx" id="pz11-8"> If you have read my novel <i>Carolina Gold</i>, this setting will be familiar to you. My fictional character Charlotte Fraser grew up spending her summers in her family’s cottage on Pawleys. For <i>A Heart So True</i> I couldn’t resist returning to a place I love to give you another glimpse of Charlotte at age fifteen, before she became mistress of Fairhaven, her father’s rice plantation on the Waccamaw River. And I’ve included a scene in which you will catch up with Celia Browning of <i>The Bracelet</i>, a year after her marriage to her childhood sweetheart, Sutton Mackay. </p>
<p class="tx" id="pz12-1"><a id="page_4"> Now I hope you will enjoy meeting a new heroine, Abby Clayton. In <i>A Heart So True</i>, a beach barbecue sets the stage for events that compel Abby to make hard choices that change the course of her future. </a></p><a id="page_4">
<p class="txr1" id="pz12-2"> Be blessed, </p>
<p class="txr1" id="pz12-3"> Dorothy </p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?5218efa6